<div class="dialog-container">
  <div class="text-center"><i class="far fa-check-circle fa-4x"></i></div>
  <h1 class="text-center">Complete!</h1>
  <p>Your Purchase Is Done Successfully</p>
  <p *ngIf="refNumber != 0">Reference number : {{refNumber}}</p>
</div>
